export default "__VITE_ASSET__DYmSvcEk__"